// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"30":"2d35fec96ceab944","998":"b7518e213b431b8d","2450":"eff1d029eca2f4b1"}[chunkId] + ".js";
};